import Fill from "ol/style/Fill";
import Stroke from "ol/style/Stroke";
import Style from "ol/style/Style";
import { ClientLayer } from "../../../lib/layers";
export class SimpleClientLayer extends ClientLayer {
    constructor(options) {
        super();
        this.name = options.name;
        this.raw.setStyle(new Style({
            fill: new Fill({
                color: options.fill_color
            }),
            stroke: new Stroke({
                color: options.stroke_color,
                width: options.stroke_width
            })
        }));
    }
}
